var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-box"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("沪ICP备20025129号-2")])])
}]

export { render, staticRenderFns }